import React, { useEffect, useState } from 'react'
import Topbar from '../components/Topbar'
import Leftbar from '../components/Leftbar'
import { Link } from 'react-router-dom'
import {
    displayError,
    displaySuccess,
  getRequestedPhysioList,
  getReviewsList,
  updateReview
} from '../Utils/utils'
import { toggleLoader } from '../actions/loader'
import { connect } from 'react-redux'
import './style.css'

const ReviewList = props => {
  const [users, setUsers] = useState([])
  const [limit, setLimit] = useState(10)
  const [skip, setSkip] = useState(0)
  const [isLargeScreen, setIsLargeScreen] = useState(false)
  const [totalPages, setTotalPages] = useState(1)
  const [showModal, setShowModal] = useState(false)
  const [selectedReview, setSelectedReview] = useState(null)
  const [isRecommended, setIsRecommended] = useState(null)
  const [politeness, setPoliteness] = useState(0)
  const [timeRating, setTimeRating] = useState(0)
  const [skillRating, setSkillRating] = useState(0)
  const [overallRating, setOverallRating] = useState(0)
  const [reviewText, setReviewText] = useState('')

  const handleResize = () => {
    setIsLargeScreen(window.innerWidth >= 1200) // Set true if width >= 1200px
  }

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const getListNew = async () => {
    props.toggleLoader(true)
    var getUsers_var = await getReviewsList(limit, skip)
    console.log('list Data:', getUsers_var)
    setUsers(getUsers_var?.data?.data)
    // setTotalPages(getUsers_var.data.metadata.totalPage)
    props.toggleLoader(false)
  }

  useEffect(() => {
    getListNew()
  }, [skip, limit])

  const openEditModal = review => {
    setSelectedReview(review)

    setPoliteness(review?.politeness || 0)
    setTimeRating(review?.time_management || 0)
    setSkillRating(review?.skills || 0)
    setOverallRating(review?.rating || 0)
    setReviewText(review?.review || '')
    setIsRecommended(review?.is_recommended)
    setShowModal(true)
  }
  const renderStars = rating => {
    return (
      <>
        {[1, 2, 3, 4, 5].map(i => (
          <i
            key={i}
            className={`fa fa-star ${
              i <= rating ? 'text-warning' : 'text-muted'
            }`}
          />
        ))}
      </>
    )
  }
  const submitEditReview = async () => {
    const payload = {
      user_id: selectedReview?.user_id,
      rating_id:selectedReview?._id,
      provider_id: selectedReview?.provider?._id,
      nri_booking_id:selectedReview?.nri_booking_id,
      nri_booking_slot_id:selectedReview?.nri_booking_slot_id,
      rating: overallRating,
      review: reviewText,
      politeness: politeness,
      time_management: timeRating,
      skills: skillRating,
      is_recommended: isRecommended
    }
    var getUsers_var = await updateReview(payload)
    console.log('UPDATE Review Response:', getUsers_var)
    if (getUsers_var?.status==200) {
      displaySuccess(getUsers_var?.message)
      setShowModal(false)
      getListNew()
    } else {
      displayError(getUsers_var?.message)
    }
  }

  const images = [
    { mark: 1, default: '/img/verybad.png', selected: '/img/reaction5.png' },
    { mark: 2, default: '/img/bad.png', selected: '/img/reaction4.png' },
    { mark: 3, default: '/img/okok.png', selected: '/img/reaction3.png' },
    { mark: 4, default: '/img/good.png', selected: '/img/reaction2.png' },
    { mark: 5, default: '/img/happy.png', selected: '/img/reaction1.png' }
  ]
  return (
    <>
      <body class='g-sidenav-show  bg-gray-100'>
        <div id='wrapper'>
          <Leftbar />
          <main className='main-content border-radius-lg'>
            <Topbar />

            <div className='header bg-primary pb-6'>
              <div className='container-fluid'>
                <div className='header-body'>
                  <div className='row align-items-center py-4'>
                    <div className='col-lg-6 col-7'>
                      <nav
                        aria-label='breadcrumb'
                        className='d-none d-md-inline-block ml-md-4'
                      >
                        <ol className='breadcrumb breadcrumb-links breadcrumb-dark'>
                          <li className='breadcrumb-item'>
                            <Link to='/dashboard'>
                              <i className='fas fa-home' />
                            </Link>
                          </li>
                          <li className='breadcrumb-item'>
                            <a href='#'>Review List</a>
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='container-fluid mt--6'>
              <div className='row'>
                <div className='col'>
                  <div className='card'>
                    <div className='card-header border-0'>
                      <div className='row'>
                        <div className='col-9'>
                          <h3 className='mb-0'>
                            Negative Reviews for Service Providers{' '}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className='table-responsive'>
                      <table className='table align-items-center table-flush'>
                        <thead className='thead-light'>
                          <tr>
                            <th>User</th>
                            <th>Provider</th>
                            <th>Avg Rating</th>
                            <th>Review</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {users?.map(review => (
                            <tr key={review._id}>
                              <td>
                                <b>{review?.user?.full_name}</b>
                              </td>

                              <td>{review?.provider?.name}</td>

                              <td>
                                {renderStars(
                                  review?.provider?.average_rating || 0
                                )}
                              </td>

                              <td style={{ maxWidth: 300 }}>
                                {review?.review}
                              </td>

                              <td>
                                <button
                                  className='btn btn-sm btn-primary'
                                  onClick={() => openEditModal(review)}
                                >
                                  Edit
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {showModal && (
                <div className='modal-backdrop-custom'>
                  <div className='modal-box'>
                    <div className='modal-header'>
                      <h4>Edit Review</h4>
                      <button onClick={() => setShowModal(false)}>✕</button>
                    </div>

                    <p className='modal-title'>Provider’s behavior</p>
                    <div className='rating-row'>
                      {images.map((img, index) => (
                        <img
                          key={index}
                          src={
                            politeness === img.mark ? img.selected : img.default
                          }
                          className='emoji'
                          onClick={() => setPoliteness(img.mark)}
                          alt=''
                        />
                      ))}
                    </div>

                    <p className='modal-title'>Time management</p>
                    <div className='rating-row'>
                      {[1, 2, 3, 4, 5].map(i => (
                        <span
                          key={i}
                          className={`star ${i <= timeRating ? 'active' : ''}`}
                          onClick={() => setTimeRating(i)}
                        >
                          ★
                        </span>
                      ))}
                    </div>

                    {/* Skill Level */}
                    <p className='modal-title'>Skill Level</p>
                    <div className='rating-row'>
                      {[1, 2, 3, 4, 5].map(i => (
                        <span
                          key={i}
                          className={`star ${i <= skillRating ? 'active' : ''}`}
                          onClick={() => setSkillRating(i)}
                        >
                          ★
                        </span>
                      ))}
                    </div>

                    <p className='modal-title'>Overall Rating</p>
                    <div className='rating-row'>
                      {[1, 2, 3, 4, 5].map(i => (
                        <span
                          key={i}
                          className={`star ${
                            i <= overallRating ? 'active' : ''
                          }`}
                          onClick={() => setOverallRating(i)}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                    <p className='modal-title'>
                      Would you recommend this provider?
                    </p>

                    <div className='radio-group'>
                      <label className='radio-label'>
                        <input
                          type='radio'
                          name='is_recommended'
                          value='yes'
                          checked={isRecommended === true}
                          onChange={() => setIsRecommended(true)}
                        />
                        Yes
                      </label>

                      <label className='radio-label'>
                        <input
                          type='radio'
                          name='is_recommended'
                          value='no'
                          checked={isRecommended === false}
                          onChange={() => setIsRecommended(false)}
                        />
                        No
                      </label>
                    </div>
                    <textarea
                      className='review-input'
                      placeholder='Write your review'
                      value={reviewText}
                      onChange={e => setReviewText(e.target.value)}
                    />

                    <div className='modal-footer'>
                      <button
                        className='btn-secondary'
                        onClick={() => setShowModal(false)}
                      >
                        Cancel
                      </button>
                      <button
                        className='btn-primary'
                        onClick={submitEditReview}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </main>
        </div>
      </body>
    </>
  )
}
const mapDispatchToProps = {
  toggleLoader
}
const mapStateToProps = state => {
  return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(ReviewList)
